import { cn } from '@/shared/lib/cn';

/**
 * Schalter „Fotos verlangen“ (Board B, PO 23.10.): an = je Raum ein Pflichtfoto, aus = die
 * Reinigung meldet nur „Erledigt“. Wirkt erst nach dem Speichern und nur auf neue Aufgaben.
 */
export function PhotoRequirementCard({
  checked,
  mixed,
  disabled,
  onChange,
}: {
  checked: boolean;
  /** Gespeichert sind Räume mit und ohne Foto — Speichern vereinheitlicht sie. */
  mixed: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <section className="border-hairline rounded-tile flex flex-col gap-2.5 border bg-white p-4">
      <div className="flex items-center gap-3">
        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
          <b id="photos-label" className="text-[15px]">
            Fotos verlangen
          </b>
          <span className="text-ink-soft text-xs leading-snug">
            {checked
              ? 'An: je Raum ein Foto; mit dem letzten ist die Aufgabe erledigt.'
              : 'Aus: die Reinigung meldet nur „Erledigt“.'}
          </span>
        </span>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          aria-labelledby="photos-label"
          disabled={disabled}
          onClick={() => onChange(!checked)}
          className="rounded-pill focus-visible:outline-forest grid min-h-11 min-w-14 flex-none place-items-center disabled:opacity-40"
        >
          <span
            aria-hidden
            className={cn(
              'rounded-pill relative h-8 w-[52px] transition-colors',
              checked ? 'bg-forest' : 'bg-line',
            )}
          >
            <span
              className={cn(
                'absolute top-1 size-6 rounded-full bg-white transition-[left]',
                checked ? 'left-[24px]' : 'left-1',
              )}
            />
          </span>
        </button>
      </div>
      <p className="bg-paper rounded-control text-ink px-2.5 py-2 text-xs leading-relaxed">
        Gilt für Aufgaben, die ab jetzt entstehen. Schon angelegte Aufgaben behalten ihre Fotoliste.
        {mixed && ' Gespeichert sind heute Räume mit und ohne Foto; Speichern stellt alle gleich.'}
      </p>
    </section>
  );
}
